/*
 * @Author: qiaoshiteng
 * @Date: 2023-09-22 14:16:03
 * @LastEditors: qiaoshiteng
 * @LastEditTime: 2023-11-28 11:10:01
 * @Description: 
 */


import config from "@/config";
import http from "@/utils/request";

export default {
	list: {
		url: `${config.MAIN_URL}/api/v1/department/data`,
		name: "查询部门列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getusers: {
		url: `${config.MAIN_URL}/department/api/users`,
		name: "查询员工列表",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	getdepartmentuser: {
		url: `${config.MAIN_URL}/api/v2/department/user`,
		name: "查询用户列表",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	userselect: {
		url: `${config.MAIN_URL}/api/v2/department/select`,
		name: "查询用户列表",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	save: {
		url: `${config.MAIN_URL}/api/v1/department/save`,
		name: "查询部门列表",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	saveuser: {
		url: `${config.MAIN_URL}/api/v2/department/user`,
		name: "部门管理添加用户",
		post: async function (params) {
			return await http.post(this.url+params);
		},
	},
	rebindUserRoles: {
		url: `${config.MAIN_URL}/api/v2/department/user/rebindUserRoles`,
		name: "部门管理添角色",
		post: async function (params) {
			return await http.post(this.url,params);
		},
	},
	deluser: {
		url: `${config.MAIN_URL}/api/v2/department/user`,
		name: "部门管理添加用户",
		put: async function (data = {}) {
			return await http.put(this.url+data);
		},
	},
	update: {
		url: `${config.MAIN_URL}/api/v1/department/update`,
		name: "查询部门列表",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	delete: {
		url: `${config.MAIN_URL}/api/v1/department/delete`,
		name: "查询部门列表",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
	deleteAlluser: {
		url: `${config.MAIN_URL}/api/v2/department/user`,
		name: "删除部门列表",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
};
